import script from "./SalesRebateSchemaCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SalesRebateSchemaCard.vue?vue&type=script&lang=ts&setup=true"

import "./SalesRebateSchemaCard.vue?vue&type=style&index=0&id=1b2118f0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2118f0"]])

export default __exports__